/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { Link } from "react-router-dom";

import type { FcWithChildren } from "types/fcWithChildren";

type Props = {
  href: string;
};

export const CardLink: FcWithChildren<Props> = (props) => {
  const { children, href } = props;

  return (
    <Link css={rootStyle} to={href}>
      {children}
    </Link>
  );
};

const rootStyle = css`
  display: block;
  height: 100%;
`;
